import ChatTable from "../../../components/ChatTable";
import { Button } from "../../../components/ui/button";
import {
  BarChartIcon,
  DownloadIcon,
  ReloadIcon,
  TableIcon,
} from "@radix-ui/react-icons";
import React, { useEffect, useState } from "react";
import { executeWidgetSqlAPI } from "../../../api/dashboardApi";
import BarGraph from "../../../components/BarGraph";
import { LoaderCircle } from "lucide-react";
import {
  downloadFile,
  getNormalizeApiData,
} from "../../../components/Chat/utils";
import { reExecuteSql } from "../../../api/messageApi";

const getCurrentDateTime = () => {
  const now = new Date();
  const formattedDateTime = now.toLocaleString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  return formattedDateTime;
};

const WidgetMainHeader = ({
  dashboardId,
  sectionId,
  widgetId,
  setData,
  activeTab,
  setActiveTab,
  msgId,
}) => {
  const [currentDateTime, setCurrentDateTime] = useState(() =>
    getCurrentDateTime()
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloadFileLoading, setIsDownloadFileLoading] = useState(false);

  const handleDownload = async () => {
    if (isDownloadFileLoading) return;

    setIsDownloadFileLoading(true);
    const apiData = await reExecuteSql(msgId);
    const normalizeApiData = getNormalizeApiData(apiData[0]?.table?.dataframe);
    downloadFile({ normalizeApiData, msgId });
    setIsDownloadFileLoading(false);
  };
  return (
    <div className="flex justify-between mt-1 mb-2">
      <div className="gap-0.5 flex ">
        <Button
          size="icon"
          onClick={() => setActiveTab("table")}
          className={`text-zinc-500 hover:bg-zinc-800 rounded-full h-7 w-7 shadow-none ${
            activeTab === "table" ? "bg-zinc-800" : ""
          }`}
        >
          <TableIcon />
        </Button>
        <Button
          onClick={() => setActiveTab("chart")}
          size="icon"
          className={`text-zinc-500 hover:bg-zinc-800 rounded-full h-7 w-7 shadow-none ${
            activeTab === "chart" ? "bg-zinc-800" : ""
          }`}
        >
          <BarChartIcon />
        </Button>
      </div>
      <div className="flex items-center gap-2">
        <div>
          <Button
            onClick={handleDownload}
            size="icon"
            className="text-zinc-500 hover:bg-zinc-800 rounded-full h-7 w-7 shadow-none"
          >
            {isDownloadFileLoading ? (
              <LoaderCircle className="animate-spin w-4 h-4" />
            ) : (
              <DownloadIcon />
            )}
          </Button>
          <Button
            onClick={async () => {
              if (isLoading) return;
              const response = await executeWidgetSqlAPI({
                setIsLoading,
                dashboardId,
                sectionId,
                widgetId,
              });
              setCurrentDateTime(getCurrentDateTime());
              setData(response);
            }}
            size="icon"
            className="text-zinc-500 hover:bg-zinc-800 rounded-full h-7 w-7 shadow-none"
          >
            {isLoading ? (
              <LoaderCircle className="animate-spin w-4 h-4" />
            ) : (
              <ReloadIcon />
            )}
          </Button>
        </div>

        <h6 className="text-xs">
          <span className="text-zinc-500">
            Last Updated at :{" "}
            <span className="text-zinc-300 text-[11px]"> {currentDateTime}</span>
          </span>
          <span></span>
        </h6>
      </div>
    </div>
  );
};

const SectionWidgetMain = ({
  firstMountRef,
  msgId,
  dashboardId,
  sectionId,
  widgetId,
}) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("table");

  useEffect(() => {
    // if (firstMountRef.current) {
    (async () => {
      const response = await executeWidgetSqlAPI({
        setIsLoading,
        dashboardId,
        sectionId,
        widgetId,
      });
      setData(response);
    })();
    // }

    return () => {
      firstMountRef.current = false;
    };
  }, []);

  return (
    <div>
      <WidgetMainHeader
        dashboardId={dashboardId}
        sectionId={sectionId}
        widgetId={widgetId}
        setIsLoading={setIsLoading}
        setData={setData}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        isLoading={isLoading}
        msgId={msgId}
      />
      {isLoading ? (
        <div className="h-96 flex justify-center items-center">
          <LoaderCircle className="animate-spin text-zinc-400" />
        </div>
      ) : (
        <>
          {activeTab === "table" ? (
            <ChatTable
              download={false}
              itemsPerPage={6}
              table_type=""
              data={data}
              msgId={msgId}
            />
          ) : null}
          {activeTab === "chart" ? (
            <div className="mt-1">
              <BarGraph data={data} />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default SectionWidgetMain;
